import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { useCallback, useMemo } from "react";
import { useUserPreference } from "./use-user-preference";

export const useStreamResourceViews = (
  dataProvider: any,
  defaultSort: any,
  defaultViews: any,
  preferenceKey: string,
) => {
  const viewsPreference = useUserPreference(preferenceKey);
  const filtersData = useMemo(() => JSON.parse(viewsPreference.value || "[]"), [viewsPreference.value]);
  const filterViews = useMemo(() => defaultViews.concat(filtersData), [filtersData]);
  const apply = useCallback(
    (uuid: string) => {
      const selectedView = filterViews.find((view: any) => view.id === uuid);
      dataProvider.setSort(selectedView?.attributes?.sort || defaultSort);
      dataProvider.omnifilters.setFilterState(Object.assign({}, selectedView?.attributes?.filters || {}));
      dataProvider.omnifilters.setDirty(false);
      dataProvider.streamQuery.scrollTop();
    },
    [
      dataProvider.omnifilters.setDirty,
      dataProvider.omnifilters.setFilterState,
      dataProvider.streamQuery.scrollTop,
      defaultSort,
      filterViews,
    ],
  );

  const save = useCallback(
    async (data: any) => {
      const uuid = uuidv4();
      const updatedFiltersData = filtersData.concat([
        {
          id: uuid,
          attributes: {
            name: data.name,
            canOverride: true,
            filters: dataProvider.omnifilters.filterState,
            sort: dataProvider.sort,
          },
        },
      ]);
      await viewsPreference.update(JSON.stringify(updatedFiltersData));
      await viewsPreference.query.refetch();
      return uuid;
    },
    [filtersData, viewsPreference, dataProvider.sort, dataProvider.omnifilters.filterState],
  );

  const deleteSelected = useCallback(
    async (selectedFilter: string) => {
      const updatedFiltersData = _.filter(filtersData, (filter: any) => filter.id !== selectedFilter);
      await viewsPreference.update(JSON.stringify(updatedFiltersData));
      apply("");
    },
    [apply, filtersData, viewsPreference],
  );

  return {
    views: filterViews,
    apply,
    save,
    delete: deleteSelected,
    isLoading: viewsPreference.isLoading,
  };
};
